import axios from "axios"
import { useState } from "react"
import { SERVER_URI } from "../utility/config"

export const CreateNewAdmin = (props) => {
	const [name, setName] = useState("")
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [key, setKey] = useState("")
	const [error, setError] = useState("")

	const handleSubmitNewAdmin = async (e) => {
    e.preventDefault()
		let response
		try {
			response = await axios.post(`${SERVER_URI}/create_new_admin/`, {
				name: name,
				email: email,
				password: password,
				key: key,
			})
		} catch (e) {
			setError("Virhe luotaessa uutta adminia: " + e.response.data.message)
			return
		}
		if (response.data.error) {
			setError("Virhe luotaessa uutta adminia: " + response.data.message)
		} else {
			setError("Uusi admin luotu onnistuneesti")
			setTimeout(() => {
				// Move to root
				window.location.href = "/"
			}, 2000)
		}
	}

	return (
		<div className="configurations">
			<h3>Luo uusi admin</h3>
			<div
				className="configurations__inputs"
				style={{ justifyContent: "right", alignItems: "right", textAlign: "right" }}>
				<form onSubmit={(e) => handleSubmitNewAdmin(e)}>
					<label htmlFor="admin_name" style={{ color: "black" }}>
						Nimi
					</label>
					<input type="text" id="admin_name" placeholder="Käyttäjänimi" onChange={(e) => setName(e.target.value)} />
					<br />
					<label htmlFor="admin_email" style={{ color: "black" }}>
						Sähköposti
					</label>
					<input type="email" id="admin_email" placeholder="Sähköposti" onChange={(e) => setEmail(e.target.value)} />
					<br />
					<label htmlFor="admin_password" style={{ color: "black" }}>
						Salasana
					</label>
					<input type="text" id="admin_password" placeholder="Salasana" onChange={(e) => setPassword(e.target.value)} />
					<br />
					<label htmlFor="admin_key" style={{ color: "black" }}>
						Avain
					</label>
					<input type="text" id="admin_key" placeholder="Avain" onChange={(e) => setKey(e.target.value)} />
					<br />
					<button
						type="submit"
						id="gradient_Button"
						disabled={!(name && email && password && key)}
						style={{ width: "100%" }}>
						Luo admin
					</button>
				</form>
				{error && <p>{error}</p>}
			</div>
		</div>
	)
}
